import { useLocation } from "react-router-dom";

export function useActivePage() {
  const location = useLocation();
  const nodes = location.pathname.split("/").slice(1);
  const page = nodes && nodes.length > 0 && nodes[0] !== "" ? nodes : ["home"];
  return page;
}
